import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import { grey } from "@mui/material/colors"

const GridCell = ({ children, col, row, flexDirection }) => (
  <Box
    sx={{
      gridColumn: col,
      gridRow: row,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: flexDirection,
    }}
  >
    {children}
  </Box>
)
GridCell.propTypes = {
  children: PropTypes.node,
  col: PropTypes.string,
  row: PropTypes.string,
  flexDirection: PropTypes.string,
}
GridCell.defaultProps = {
  flexDirection: "column",
}

export default GridCell
